export enum CarMarketState {
	Create = 'create',
	InfoPlayer = 'infoPlayer',
	InfoSeller = 'infoSeller',
	Edit = 'edit',
}

export const carMarketHeadTitle = {
	[CarMarketState.Create]: 'Авторынок',
	[CarMarketState.InfoPlayer]: 'Об автомобиле',
	[CarMarketState.InfoSeller]: 'Об автомобиле',
	[CarMarketState.Edit]: 'Редактирование',
};
